/** biome-ignore-all lint/suspicious/noExplicitAny: allow any */
import cx from 'classnames';
import {pluralize} from '~/common/utils';
import {isHost} from '~/ViewInvitation/utils';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {CheckmarkCircleIcon} from '~library/svg/CheckmarkCircleIcon';
import {ChevronIcon} from '~library/svg/ChevronIcon';
import {emerald} from '~libSass/base/_exports.sass';
import {Option} from './PollModule';

interface PollResultProps {
  option: Option;
  userChoice?: string | number;
  totalResponses: number;
  preview: boolean;
  onClick: (choice: string) => void;
}

export const PollResult = ({
  option,
  userChoice,
  totalResponses,
  preview,
  onClick,
}: PollResultProps) => {
  const {key, response_count, choice} = option;

  const isUserHost = isHost();
  const userSelected = key === userChoice;
  const ctNum = Number(response_count);
  const noVotes = !ctNum;
  const barWidth = !response_count ? '0' : `${(ctNum / totalResponses) * 100}%`;

  return (
    <div className="view-invitation__poll-result" key={`pollOption_${key}`}>
      <div className="view-invitation__poll-result-details">
        <Typography
          className="view-invitation__poll-result-label"
          semibold={userSelected}
          variant="paragraph2"
          data-qa-id="poll-option"
          data-qa-value={key}
        >
          {choice}
          {userSelected && <CheckmarkCircleIcon ratio={0.5} color={emerald} />}
        </Typography>
        <Button
          className={cx({
            'view-invitation__poll-result-btn__no-click': noVotes || !isUserHost,
          })}
          data-qa-id="view-poll-choice-overlay"
          variant="unstyled-button"
          size="small"
          onClick={() => {
            if (!noVotes && isUserHost) onClick(choice);
          }}
          disabled={preview}
        >
          <Typography
            className="view-invitation__poll-result-count"
            variant="paragraph2"
            data-qa-id="poll-option-response-count"
            data-qa-value={response_count}
          >
            {pluralize('vote', ctNum || 0)}
          </Typography>
          {!noVotes && isUserHost && <ChevronIcon ratio={0.5} />}
        </Button>
      </div>
      <div className="view-invitation__poll-result-bar">
        <div className="view-invitation__poll-result-bar-inner" style={{width: barWidth}} />
      </div>
    </div>
  );
};
